import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CurrentStepState, StepDirection, StepId } from './interfaces'

export const initialState: CurrentStepState = {
  current: undefined,
  direction: StepDirection.FORWARD,
  previous: [],
  next: [],
}

export interface NextStepPayload {
  id: StepId
  disablePersistence?: boolean
}

interface GotoStepPayload {
  id: StepId
}

export const stepSlice = createSlice({
  name: 'step',
  initialState,
  reducers: {
    clearNext: (state: CurrentStepState) => {
      state.next = []
    },
    clearSteps: (state: CurrentStepState) => {
      state.previous = []
      state.next = []
    },
    gotoStep: (state: CurrentStepState, action: PayloadAction<GotoStepPayload>) => {
      state.current = action.payload.id
    },
    nextStep: (state: CurrentStepState, action: PayloadAction<NextStepPayload | undefined>) => {
      if (!action.payload?.disablePersistence) {
        state.current && state.previous.push(state.current)
      }

      state.current = action.payload?.id || state.next.pop()!

      if (action.payload?.id) {
        state.next = []
      }

      state.direction = StepDirection.FORWARD
    },
    previousStep: (state: CurrentStepState) => {
      const previous = state.previous.pop()!

      if (state.current) {
        state.next.push(state.current)
      }

      state.current = previous
      state.direction = StepDirection.BACKWARD
    },
  },
})

export const { clearNext, clearSteps, nextStep, previousStep, gotoStep } = stepSlice.actions
